<div id="findbarOptionsOneContainer">
  <pdf-find-highlight-all></pdf-find-highlight-all>
  <pdf-find-match-case></pdf-find-match-case>
</div>
